import React from 'react';

const DivisionSymbol = () => {
	return (
		<>
			<div className="division-symbol">/</div>
		</>
	);
};

export default DivisionSymbol;
